<template>
  <div>
    <v-row no-gutters>
      <mf-tooltip v-for="(option, index) in options" :key="`option-${index}`" :disabled="!option.tooltip" variant="secondary" top max-width="350">
        <template v-slot:activator>
          <v-chip
            class="toggle-button"
            :class="{
              'toggle-button-selected': option.value === localSelectedOptionValue,
              'toggle-button-disabled': option.disabled,
              'toggle-button-error': error,
              'mr-3': true,
            }"
            :disabled="disabled"
            @click="select(option)"
          >
            {{ option.label }}
          </v-chip>
        </template>
        <span> {{ option.tooltip }} </span>
      </mf-tooltip>
    </v-row>
    <v-row v-if="disabled && disabledText" no-gutters class="pt-1">
      <span class="texto-corrido-pequeno">{{ disabledText }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  components: {},
  props: {
    value: {
      type: String,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: String,
    },
  },
  data: () => ({
    localSelectedOptionValue: null,
  }),
  computed: {
    lazySelectedOptionValue: {
      set(value) {
        this.localSelectedOptionValue = value
        this.$emit('input', value)
      },
      get() {
        return this.localSelectedOptionValue
      },
    },
  },
  watch: {
    value(value) {
      this.localSelectedOptionValue = value
    },
  },

  mounted() {
    this.localSelectedOptionValue = this.value
  },
  methods: {
    select(option) {
      this.lazySelectedOptionValue = option.value
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-button {
  color: $marca-0-l20 !important;
  padding: 10px 14px;
  background: transparent !important;
  border: 1px solid $marca-0-l20;
  cursor: pointer;

  &:hover {
    background: $marca-0-l90 !important;
  }
}

.toggle-button-selected {
  color: $branco !important;
  background: $marca-0-l20 !important;
  border: 1px solid $marca-0-l20 !important;

  &:hover {
    background: $marca-0-l20 !important;
  }
}

.toggle-button-error {
  color: $vermelho-0 !important;
  background: transparent !important;
  border: 1px solid $vermelho-0 !important;

  &:hover {
    background: transparent !important;
  }
}

.toggle-button-disabled {
  color: $cinza-l70 !important;
  background: transparent !important;
  border: 1px solid $cinza-l70 !important;
  opacity: 1 !important;

  &:hover {
    background: transparent !important;
  }
}

.tooltip-title {
  span {
    color: $marca-0;
    font-size: 16px;
  }
}
</style>
